<template>
  <div 
    v-if="tippyGuideStore.enableOverlay"
    class="fixed w-screen h-screen top-0 left-0 bg-white opacity-40 z-100"
  />
</template>

<script>
import useTippyGuideStore from '@/frontapp/store/tippyGuide'
import { mapStores } from 'pinia'

export default {
  computed: {
    ...mapStores( useTippyGuideStore )
  }
}
</script>

<style lang="scss" scoped></style>
